import { InsuranceModeEnum } from '@aid/insurances/types/enums';

export class InsuranceMode {
  id?: number;
  name?: string;
  identifier?: InsuranceModeEnum;
}
